import { AppDownload } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/AppDownload";
import { Column, HorizontalLine } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import * as React from "react";
import styled from "styled-components";

export const LoggedOutAppDownloadCTA: React.FC = () => (
  <>
    <MobileOnlyHorizontalLine />
    <Container>
      <Typography variant="pageHeaderSerifRegular">
        <StrictLocalMsg
          defaultMessage="Get the Faire wholesale app"
          description={{
            text: "Prompt for user to download the Faire app",
            img: "https://cdn.faire.com/fastly/602c38fdc19d623fb3431135ba8367a6f3ca0693871fc58945a4f1662c90a291.png",
          }}
        />
      </Typography>
      <Spacer size="1x" />
      <Typography variant="paragraphSansRegular">
        <StrictLocalMsg
          defaultMessage="Shop on the go, message brands, and track orders with the Faire app."
          description={{
            text: "Message describing the benefits of the Faire app",
            img: "https://cdn.faire.com/fastly/8886233fe3a21ea9f5606277d4f3fd86f785f0c8c7dd8b8bcbc9b4d79727528c.png",
          }}
        />
      </Typography>
      <Spacer size="2x" />
      <AppDownload loggedOut noModal={useViewport().isMobile} />
    </Container>
  </>
);

const Container = styled(Column)`
  ${responsiveMediaQueries.mobile} {
    padding: ${getSpacing("3x")};
  }

  ${responsiveMediaQueries.tabletAndAbove} {
    max-width: ${getSpacing(400)};
    padding: ${getSpacing("4x", "8x", "8x", "10x")};
  }

  ${responsiveMediaQueries.desktopAndAbove} {
    padding: ${getSpacing("3x", 96, "5x", 0)};
  }
`;

const MobileOnlyHorizontalLine = styled(HorizontalLine)`
  ${responsiveMediaQueries.tabletAndAbove} {
    display: none;
  }
`;
